<div class="box">
  <div class="modal-header">
    <h2 class="modal-title pull-left mr-4">{{ 'LOGIN' | translate }}</h2>
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide()"
    ></button>
  </div>

  @if (!isEmailMissing) {
    <form #form="ngForm" #formEl (ngSubmit)="sendLogin()" spellcheck="false">
      <div class="modal-body">
        <div class="tabs tabs--in-box">
          <div class="nav" id="nav-tab" role="tablist">
            @for (type of types; track type) {
              <a
                class="nav-item nav-link"
                role="tab"
                [class.active]="type === activeType"
                (click)="changeTab(type)"
                >{{ typesMap.get(type) | translate }}</a
              >
            }
          </div>
          <div class="tabs__line" aria-hidden="true"></div>
        </div>
        <div class="tab-content" @parent>
          @switch (activeType) {
            @case ('individual') {
              <div class="form-control" @fadeInOut>
                <label for="phone">{{ 'PHONE_NUMBER' | translate }} </label>
                <ngx-intl-tel-input
                  [onlyCountries]="['by', 'ru']"
                  name="login"
                  appAutofocus
                  required
                  mobilePhone
                  ngModel
                  (ngModelChange)="
                    phone = $event ? $any($event).internationalNumber : ''
                  "
                  ngxTelInputPlaceholder
                ></ngx-intl-tel-input>
                <app-control-errors control="login"></app-control-errors>
              </div>
            }
            @case ('legal') {
              <div class="form-control" @fadeInOut>
                <label for="tpi-login">{{ 'TPI_OR_EMAIL' | translate }}</label>
                <input
                  type="text"
                  name="login"
                  id="tpi-login"
                  [(ngModel)]="tpi"
                  required
                  maxlength="255"
                  appAutofocus
                  [asterisk]="false"
                />
                <app-control-errors control="login"></app-control-errors>
              </div>
              <app-filial-selector
                name="filial"
                [(ngModel)]="filial"
                [unp]="tpi"
              >
                <app-control-errors control="filial"></app-control-errors>
              </app-filial-selector>
            }
          }
          <div class="form-control">
            <label for="password-login">{{ 'PASSWORD' | translate }}</label>
            <div class="position-relative">
              <input
                type="password"
                name="password"
                id="password-login"
                class="pr-5"
                required
                [(ngModel)]="password"
                appPassword
                [asterisk]="false"
              />
            </div>
            <app-control-errors control="password"></app-control-errors>
          </div>
        </div>
        <div class="text-center mb-3">
          <a class="pointer" (click)="openForgotPassword()">{{
            'FORGOT_PASSWORD' | translate
          }}</a>
        </div>
        @if (form.errors) {
          <app-control-errors>
            <div class="text-center mb-2">
              @if (isResendConfirmationAvailable) {
                <button
                  (click)="isEmailMissing = true"
                  class="text-link"
                  type="button"
                >
                  {{ 'EMAIL_MISSING' | translate }}
                </button>
              }
            </div>
          </app-control-errors>
        }
      </div>
      <div class="modal-footer">
        <app-loading-button
          type="submit"
          [loading]="isLoading"
          [disabled]="isLoading || (form.submitted && form.invalid)"
          buttonClass="button button--filled button--shadow"
        >
          {{ 'LOG_IN' | translate }}
        </app-loading-button>
        <button
          type="button"
          class="button button--outlined"
          (click)="openRegistration()"
        >
          {{ 'REGISTER' | translate }}
        </button>
      </div>
    </form>
  } @else {
    <form
      #formEmail="ngForm"
      #formEmailEl
      (ngSubmit)="resendEmail()"
      spellcheck="false"
    >
      <div class="modal-body">
        <!-- Enter sms code -->
        <p>{{ 'MISSING_EMAIL_DESC' | translate }}</p>
        <div class="form-control">
          <label for="email-login">{{ 'EMAIL' | translate }}</label>
          <div class="position-relative">
            <input
              type="email"
              name="email"
              id="email-login"
              [(ngModel)]="email"
              placeholder="{{ 'EMAIL_PLACEHOLDER' | translate }}"
              email
              maxlength="255"
              appAutofocus
            />
          </div>
          <app-control-errors control="email"></app-control-errors>
        </div>
        <div class="text-center mb-3">
          <a class="pointer" (click)="isEmailMissing = false">{{
            'LOGIN_FOR_REGISTERED' | translate
          }}</a>
        </div>
        <app-control-errors></app-control-errors>
      </div>
      <div class="modal-footer">
        <app-loading-button
          [disabled]="isLoading || (formEmail.submitted && formEmail.invalid)"
          [loading]="isLoading"
          type="submit"
          buttonClass="button button--filled button--shadow"
        >
          {{ 'CONTINUE' | translate }}
        </app-loading-button>
      </div>
    </form>
  }
</div>
